import { ReactNode } from 'react';

import { SidebarContext, useSidebarState } from '../hooks/useSidebar';

interface SidebarProviderProps {
    children: ReactNode;
}

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
    const sidebarState = useSidebarState();

    return <SidebarContext.Provider value={sidebarState}>{children}</SidebarContext.Provider>;
};
